module.exports = __webpack_public_path__ + "img/avatar.7823362a.png";